import { render, staticRenderFns } from "./actualScore2.vue?vue&type=template&id=e7c693de&scoped=true&"
import script from "./actualScore2.vue?vue&type=script&lang=js&"
export * from "./actualScore2.vue?vue&type=script&lang=js&"
import style0 from "./actualScore2.vue?vue&type=style&index=0&id=e7c693de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c693de",
  null
  
)

export default component.exports